module.exports = __webpack_public_path__ + "img/raison-logo-name-full-white.15c28402.webp";